import React from 'react';
import { Typography } from '@material-ui/core';
import '~/app/Components/Common/css/ClickableTypography.css';

/**
 * A Typography component for clickable text. Pointer cursor styling is applied
 * via the .clickableTypography CSS class defined in ClickableTypography.css.
 *
 * @component
 * @category Common
 */
const ClickableTypography = ({ children, className, onClick, ...props }) => (
  <Typography
    {...props}
    className={['clickableTypography', className].filter(Boolean).join(' ')}
    onClick={onClick}
    role={onClick ? 'button' : undefined}
    tabIndex={onClick ? 0 : undefined}
  >
    {children}
  </Typography>
);

export default ClickableTypography;
